import { URLParser } from '../utils/URLParser';

export const searchParamsIncludeKey = (searchParam) => {
  return (traffic) => {
    const urlObject = new URLParser(traffic.url);
    const value = urlObject.searchParams.get(searchParam);
    return value !== null;
  };
};
